import { useEffect, useRef } from "react";

/**
 * Soft gold light following the cursor with eased lag. Desktop only.
 * Disabled when prefers-reduced-motion or no fine pointer.
 */
export default function CursorGlow() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (reduced || !fine) return;

    const el = ref.current;
    if (!el) return;

    let tx = window.innerWidth / 2;
    let ty = window.innerHeight / 2;
    let x = tx;
    let y = ty;
    let raf = 0;

    const onMove = (e: PointerEvent) => {
      tx = e.clientX;
      ty = e.clientY;
    };
    const tick = () => {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      el.style.transform = `translate3d(${x - 300}px, ${y - 300}px, 0)`;
      raf = requestAnimationFrame(tick);
    };
    el.style.opacity = "1";
    window.addEventListener("pointermove", onMove, { passive: true });
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("pointermove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="pointer-events-none fixed top-0 left-0 z-[1] hidden md:block"
      style={{
        width: 600,
        height: 600,
        opacity: 0,
        transition: "opacity 600ms ease-out",
        background:
          "radial-gradient(circle, rgba(201,168,107,0.18) 0%, rgba(201,168,107,0.06) 30%, transparent 65%)",
        mixBlendMode: "screen",
        willChange: "transform",
      }}
    />
  );
}
